
















import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import GEFormFields from '@/Types/GEFormFields';
import {SchemaFieldIfCallback} from '@/Types/SchemaField';

@Component({})
export default class YesNoUnsureInput extends Vue {
    static COMPONENT_NAME = 'yes-no-unsure-input'

    static YES = 'yes'
    static NO = 'no'
    static UNSURE = 'unsure'

    static isYes(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoUnsureInput.YES
    }

    static isNo(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoUnsureInput.NO
    }

    static isUnsure(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoUnsureInput.UNSURE
    }

    @Prop({type: Object, default: () => {}}) options!: Record<string, string>

    get appendedOptions(): Record<string, string> {
        const opts = {
            [YesNoUnsureInput.YES]: 'Yes',
            [YesNoUnsureInput.NO]: 'No',
            [YesNoUnsureInput.UNSURE]: 'Unsure',
        }

        return {
            ...opts,
            ...this.$props.options
        }
    }
}
